<template>
  <ul class="frisbuy-modal-media-list">
    <li
      v-for="(media, idx) in props.mediaList"
      :key="idx"
      class="frisbuy-modal-media-list__item"
      :class="{
        'frisbuy-modal-media-list__item--selected':
          props.selectedMediaThumbnailUrl &&
          media.thumbnailUrl === props.selectedMediaThumbnailUrl,
      }"
      @click="() => emit('selectMedia', media)"
    >
      <img
        class="frisbuy-modal-media-list__image"
        :src="DomainSubstitute(media.thumbnailUrl)"
        @error="errorImageHandler"
      />

      <span
        v-if="media.videoUrl.length > 0"
        class="frisbuy-modal-media-list__play-icon"
      >
        <svg
          v-if="props.playIconVariant === 'mobileSheet'"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="24" cy="24" r="16" fill="#212121" fill-opacity="0.2"/>
          <g opacity="0.8">
            <path d="M28.1192 22.7772C28.8701 23.2446 28.8701 24.4239 28.1192 24.8912L22.6451 28.2979C21.8999 28.7616 20.9727 28.1756 20.9727 27.2409L20.9727 20.4276C20.9727 19.4928 21.8999 18.9068 22.6451 19.3706L28.1192 22.7772Z" fill="white"/>
            <path d="M34.125 24.0005C34.125 18.4083 29.5921 13.8744 24 13.8742C18.4076 13.8742 13.8737 18.4081 13.8737 24.0005C13.8739 29.5926 18.4078 34.1255 24 34.1255C29.592 34.1252 34.1248 29.5925 34.125 24.0005ZM36.7917 24.0005C36.7914 31.0652 31.0647 36.7919 24 36.7922C16.935 36.7922 11.2073 31.0654 11.207 24.0005C11.207 16.9354 16.9349 11.2075 24 11.2075C31.0649 11.2078 36.7917 16.9355 36.7917 24.0005Z" fill="white"/>
          </g>
        </svg>

        <svg
          v-else
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="12" fill="#212121" fill-opacity="0.2"/>
          <g opacity="0.8">
            <path d="M23.0864 19.0829C23.6497 19.4335 23.6497 20.3179 23.0864 20.6684L18.9809 23.2234C18.422 23.5712 17.7266 23.1317 17.7266 22.4307L17.7266 17.3207C17.7266 16.6196 18.422 16.1801 18.9809 16.528L23.0864 19.0829Z" fill="white"/>
            <path d="M27.5947 20.0004C27.5947 15.8062 24.1951 12.4058 20.001 12.4056C15.8067 12.4056 12.4062 15.8061 12.4062 20.0004C12.4064 24.1945 15.8068 27.5941 20.001 27.5941C24.195 27.5939 27.5945 24.1944 27.5947 20.0004ZM29.5947 20.0004C29.5945 25.2989 25.2995 29.5939 20.001 29.5941C14.7023 29.5941 10.4064 25.299 10.4062 20.0004C10.4062 14.7015 14.7021 10.4056 20.001 10.4056C25.2997 10.4058 29.5947 14.7016 29.5947 20.0004Z" fill="white"/>
          </g>
        </svg>
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import widgetTypes from "@/common/consts/widgetTypes";
import { imageWithPostId } from "../interfaces";

const props = defineProps<{
  mediaList: Array<imageWithPostId>;
  selectedMediaThumbnailUrl?: string;
  playIconVariant?: "default" | "mobileSheet";
}>();

const emit = defineEmits<{
  (e: "selectMedia", media: imageWithPostId): void;
}>();

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}
</script>

<style scoped lang="scss">
.frisbuy-modal-media-list {
  display: grid;
  grid-template-columns: repeat(6, 48px);
  gap: 8px;
  list-style: none;
  width: fit-content;
  max-width: 100%;
  padding: 4px;
  margin: 0;
}

.frisbuy-modal-media-list__item {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  cursor: pointer;
}

.frisbuy-modal-media-list__item--selected::after {
  content: "";
  position: absolute;
  inset: -4px;
  border: 1px solid #212121;
  border-radius: 4px;
  pointer-events: none;
}

.frisbuy-modal-media-list__image {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  object-fit: cover;
}

.frisbuy-modal-media-list__play-icon {
  position: absolute;
  inset: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  z-index: 1;

  svg {
    width: 40px;
    height: 40px;
  }
}

.frisbuy-modal-media-list__play-icon svg[width="48"] {
  width: 48px;
  height: 48px;
}
</style>
